import MiscellaneousService from '@/services/api/leaderboard-service'
import UserService from '@/services/api/user-service'
import { useAppStore } from '@/stores/app'
import { useUserStore } from '@/stores/user'
import type { SchoolT } from '@/types/User'
import { storeToRefs } from 'pinia'

export const useUser = () => {
  const { setUser } = useUserStore()
  const { schools } = storeToRefs(useAppStore())

  const fetchUserProfile = async () => {
    try {
      const { data } = await UserService.getProfile()
      setUser(data)
    } catch (error) {
      console.error('Failed to fetch user profile:', error)
    }
  }

  const fetchAllSchools = async () => {
    try {
      const { data } = await MiscellaneousService.getAllSchools()
      schools.value = data as SchoolT[]
    } catch (error) {
      console.error('Failed to fetch schools:', error)
    }
  }

  return { fetchUserProfile, fetchAllSchools }
}
